export const messages = {
  en: {
    contractPartyaManage: {
      search: {
        title: 'Search Conditions',
        partyA: 'Party A',
        aContacts: 'Party A Contact',
        aLink: 'Contact Phone'
      },
      list: {
        title: 'Contract Party A'
      },
      table: {
        partyA: 'Party A',
        aContacts: 'Party A Contact',
        aLink: 'Contact Phone'
      },
      form: {
        partyA: 'Party A',
        partyAPlaceholder: 'Please enter Party A',
        aContacts: 'Party A Contact',
        aContactsPlaceholder: 'Please enter Party A Contact',
        aLink: 'Contact Phone',
        aLinkPlaceholder: 'Please enter Contact Phone'
      },
      validate: {
        partyARequired: 'Party A is required',
        partyAMaxLength: 'Party A is too long',
        aContactsRequired: 'Party A Contact is required',
        aContactsMaxLength: 'Party A Contact cannot exceed 64 characters',
        aLinkRequired: 'Contact Phone is required',
        aLinkFormat: 'Invalid Contact Phone format',
        partyaIdRequired: 'Party A ID is required'
      },
      add: {
        title: 'Add Party A'
      },
      edit: {
        title: 'Edit Party A'
      },
      delete: {
        title: 'Confirm Operation',
        confirmText: 'Are you sure to delete this Party A?'
      },
      fetchError: 'Failed to fetch Party A data'
    }
  },
  zh: {
    contractPartyaManage: {
      search: {
        title: '查询条件',
        partyA: '甲方',
        aContacts: '甲方联系人',
        aLink: '联系电话'
      },
      list: {
        title: '合同甲方'
      },
      table: {
        partyA: '甲方',
        aContacts: '甲方联系人',
        aLink: '联系电话'
      },
      form: {
        partyA: '甲方',
        partyAPlaceholder: '请输入甲方',
        aContacts: '甲方联系人',
        aContactsPlaceholder: '请输入甲方联系人',
        aLink: '联系电话',
        aLinkPlaceholder: '请输入联系电话'
      },
      validate: {
        partyARequired: '甲方不能为空',
        partyAMaxLength: '甲方太长',
        aContactsRequired: '甲方联系人不能为空',
        aContactsMaxLength: '甲方联系人不能超过64个字符',
        aLinkRequired: '联系电话不能为空',
        aLinkFormat: '联系电话格式错误',
        partyaIdRequired: '甲方编号不能为空'
      },
      add: {
        title: '添加甲方'
      },
      edit: {
        title: '修改甲方'
      },
      delete: {
        title: '请确认您的操作',
        confirmText: '确定删除合同甲方吗?'
      },
      fetchError: '获取甲方数据失败'
    }
  }
}